export const WARNING_REORDER = {
  banner: 'reorder-warning-banner',
  unavailableItem: 'reorder-unavailable-item-text',
  unavailableModifier: 'reorder-unavailable-modifier-text',
};
